import React, { useState, useEffect } from 'react';
import { Button, Card, Container, Row, Col, FormGroup, FormControl, FormLabel, Form } from 'react-bootstrap';
import { QrReader } from 'react-qr-reader';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useGuestContext } from "../../../../contexts/GuestContext";
import axios from 'axios';

const MySwal = withReactContent(Swal);

function ChingMingCheckAdminForm() {

    const { language } = useGuestContext();
    const [guestID, setGuestID] = React.useState(null);
    const [firstname, setFirstname] = React.useState(null);
    const [lastname, setLastname] = React.useState(null);
    const [phone, setPhone] = React.useState(null);
    const [email, setEmail] = React.useState(null);
    const [chinesename, setChinesename] = React.useState(null);
    const [userData, setUserData] = React.useState([]);


    const handleScan = (data) => {
        if (data) {
            window.location.href = data; // Redirect to the scanned URL
            MySwal.close(); // Close the SweetAlert modal
        }
    };

    const handleError = (err) => {
        console.error(err);
    };

    const startScan = () => {
        MySwal.fire({
            title: 'Scan QR Code',
            html: <QrReader
                constraints={{
                    facingMode: "environment",
                }}
                key="environment"
                delay={300}
                onError={handleError}
                onResult={(result, error) => {
                    if (!!result) {
                        handleScan(result?.text);
                    }
                    if (!!error) {
                        handleError(error);
                    }
                }}
                style={{ width: '100%' }}

            />,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            willClose: () => {
                // Any cleanup or state management you need to do when the modal closes
            }
        });
    };

    const checkInGuest = () => {
        const guestIdInt = parseInt(guestID, 10);

        if (!isNaN(guestIdInt) && guestIdInt > 0) {
            // ChingMing is a single event, go directly to check-in page
            window.location.href = `/chingming/checkin?guestid=${guestIdInt}`;
        } else {
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please enter a valid Guest ID.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        }
    };


    const searchGuest = async () => {
        const trimmedFirstname = firstname ? firstname.trim() : '';
        const trimmedLastname = lastname ? lastname.trim() : '';
        const trimmedEmail = email ? email.trim() : '';
        const trimmedPhone = phone ? phone.trim() : '';

        if (!trimmedFirstname && !trimmedLastname && !trimmedEmail && !trimmedPhone) {
            MySwal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: 'Please fill in at least one field to search for a guest.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        } else {
            const payload = {
                firstname: trimmedFirstname,
                lastname: trimmedLastname,
                email: trimmedEmail,
                phone: trimmedPhone
            };

            try {
                const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/chingming/searchguest`, payload);
                setUserData(response.data);

                if (response.data && response.data.length > 0) {
                    MySwal.fire({
                        title: 'Select a Guest to Check-in',
                        width: '800px',
                        html: <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="text-center"></th>
                                        <th className="text-center">ID</th>
                                        <th className="text-center">Name</th>
                                        <th className="text-center">Phone</th>
                                        <th className="text-center">Timeslot</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {response.data.map((user, index) => (
                                        <tr key={user.id}>
                                            <td className="text-center"><input type="radio" name="userSelection" value={user.id} /></td>
                                            <td className="text-center">{user.id}</td>
                                            <td className="text-center">{`${user.firstname} ${user.lastname}`}</td>
                                            <td className="text-center">{user.phone}</td>
                                            <td className="text-center">{user.timeslot || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>,
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Next',
                        cancelButtonText: 'Cancel',
                        preConfirm: () => {
                            const selectedUserId = document.querySelector('input[name="userSelection"]:checked');
                            if (!selectedUserId) {
                                MySwal.showValidationMessage('Please select a guest');
                            }
                            return selectedUserId ? selectedUserId.value : null;
                        }
                    }).then((result) => {
                        if (result.value) {
                            // ChingMing single event - go directly to check-in
                            window.location.href = `/chingming/checkin?guestid=${result.value}`;
                        }
                    });
                } else {
                    MySwal.fire({
                        icon: 'info',
                        title: 'No Matches',
                        text: 'No guest meets the search criteria. Attendee might have not registered.',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    });
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    MySwal.fire({
                        icon: 'info',
                        title: 'No Matches',
                        text: 'No guest meets the search criteria. Attendee might have not registered.',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    });
                } else {
                    MySwal.fire({
                        icon: 'error',
                        title: 'Failed to Search',
                        text: 'There was a problem searching for the guest. Please try again.',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    });
                    console.error('Search guest failed:', error);
                }
            }
        }
    };


    const handleExpressRegistration = () => {
        MySwal.fire({
            title: 'Express Registration',
            html: `
                <input id="swal-input1" class="swal2-input" placeholder="First Name">
                <input id="swal-input2" class="swal2-input" placeholder="Last Name">
                <select id="swal-input3" class="swal2-input" style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; margin-top: 10px; font-size: 16px; background-color: white;">
                    <option value="" style="font-size: 16px; padding: 8px;">Select Group Size</option>
                    ${Array.from({ length: 15 }, (_, i) => `<option value="${i + 1}" style="font-size: 16px; padding: 8px;">${i + 1} ppl</option>`).join('')}
                </select>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            preConfirm: () => {
                const firstName = document.getElementById('swal-input1').value.trim();
                const lastName = document.getElementById('swal-input2').value.trim();
                const groupSize = document.getElementById('swal-input3').value;

                if (!firstName || !lastName) {
                    MySwal.showValidationMessage('Both first name and last name are required');
                    return false;
                }

                if (!groupSize) {
                    MySwal.showValidationMessage('Please select a group size');
                    return false;
                }

                return { firstName, lastName, groupSize: parseInt(groupSize) };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.post(`${process.env.REACT_APP_SERVER_URL}/chingming/expressregistration`, {
                    firstname: result.value.firstName,
                    lastname: result.value.lastName,
                    groupSize: result.value.groupSize
                })
                    .then(response => {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Registration Successful',
                            text: `The guest has been successfully registered and checked in for a group of ${result.value.groupSize}.`,
                        });
                    })
                    .catch(error => {
                        MySwal.fire({
                            icon: 'error',
                            title: 'Registration Failed',
                            text: 'There was a problem with the registration. Please try again.',
                        });
                        console.error('Express registration failed:', error);
                    });
            }
        });
    };


    return (
        <>
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card>
                            <Card.Header>
                                <Card.Title as="h4" className="font-weight-bold text-center mb-2">Ching Ming Event Check-in</Card.Title>
                                <hr />
                            </Card.Header>
                            <Card.Body>
                                <Row className='mb-3'>
                                    <Col md="12" className="text-center">
                                        <h6 className='text-center'>Scenario 1: QR Code Checkin</h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <Button className="btn-fill font-weight-bold" variant="info" onClick={startScan}>
                                            Scan QR Code
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <Row className='mb-3'>
                                    <Col md="12" className="text-center">
                                        <h6 className='text-center'>Scenario 2: Guest ID Checkin</h6>
                                    </Col>
                                </Row>

                                <Row className='mb-3 text-center'>
                                    <Col md={{ span: 10, offset: 1 }}>
                                        <FormGroup>
                                            <FormLabel>
                                                <h6 className="font-weight-bold">Guest ID</h6>
                                            </FormLabel>
                                            <FormControl
                                                type="number"
                                                name="guestID"
                                                placeholder="ex: 12345"
                                                value={guestID}
                                                onChange={(event) => setGuestID(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <Button className="btn-fill font-weight-bold" variant="success" onClick={checkInGuest}>
                                            Check-in Guest
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <Row className='mb-3'>
                                    <Col md="12" className="text-center">
                                        <h6 className='text-center'>Scenario 3: Search Guest</h6>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{ span: 5, offset: 1 }}>
                                        <FormGroup>
                                            <FormLabel>
                                                {language === "English" ? "First Name" : "英文名"}
                                            </FormLabel>
                                            <FormControl
                                                type="text"
                                                name="firstname"
                                                placeholder="ex: Mike"
                                                value={firstname}
                                                onChange={(event) => setFirstname(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <FormLabel>
                                                {language === "English" ? "Last Name " : "英文姓"}
                                            </FormLabel>
                                            <FormControl
                                                type="text"
                                                name="lastname"
                                                placeholder="ex: Andrew"
                                                value={lastname}
                                                onChange={(event) => setLastname(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={{ span: 5, offset: 1 }}>
                                        <FormGroup>
                                            <FormLabel>
                                                {language === "English" ? "Phone Number " : "電 話 號 碼"}
                                            </FormLabel>
                                            <FormControl
                                                type="number"
                                                name="phone"
                                                maxLength="30"
                                                placeholder="ex: 0433233343"
                                                value={phone}
                                                onChange={(event) => setPhone(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <FormLabel>
                                                {language === "English" ? "Email" : "電 子 郵 件"}
                                            </FormLabel>
                                            <FormControl
                                                type="email"
                                                name="email"
                                                maxLength="50"
                                                placeholder="ex: wukong@baolin.com"
                                                value={email}
                                                onChange={(event) => setEmail(event.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center mt-2">
                                        <Button className="btn-fill font-weight-bold" variant="warning" onClick={searchGuest}>
                                            Search Guest
                                        </Button>
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col md="12" className="text-center mt-2">
                                        <Row className='mb-3'>
                                            <Col md="12" className="text-center">
                                                <h6 className='text-center'>Scenario 4: Walk-in Guest</h6>
                                            </Col>
                                        </Row>
                                        <Button className="btn-fill font-weight-bold" variant="primary" onClick={handleExpressRegistration}>
                                            Express Registration
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ChingMingCheckAdminForm;
